import React, { useEffect, useRef, useState, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import styles from "./TestimonialWidget.module.css";
import useDeviceWidth from "../../../../components/device-width/UseDeviceWidth";

function TestimonialWidget({ data }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);
  const width = useDeviceWidth();

  // Clean up Swiper on unmount
  useEffect(() => {
    return () => {
      if (swiperRef.current) {
        swiperRef.current.destroy(true, true);
      }
    };
  }, []);

  // Memoized slides to prevent re-rendering
  const slides = useMemo(() => {
    if (!data?.listingItems?.length) return [];

    return data.listingItems.map((slide, index) => (
      <SwiperSlide
        key={index}
        className={`${styles.slide} ${activeIndex === index ? styles.activeSlide : ""}`}
      >
        <div
          className={`${activeIndex !== index ? styles.centerCard : styles.card} bg-primary-500`}
        >
          <img
            className={styles.testimonialComma}
            src="/img/icons/testimonial-comma.svg"
            alt="Quote"
            loading="lazy"
          />
          {activeIndex === index && (
            <>
              <img
                className={`${styles.navButton} ${styles.left}`}
                src="/img/icons/white-left-arrow.svg"
                onClick={() => swiperRef.current.slidePrev()}
                alt="Previous"
                loading="lazy"
              />
              <img
                className={`${styles.navButton} ${styles.right}`}
                src="/img/icons/white-right-arrow.svg"
                onClick={() => swiperRef.current.slideNext()}
                alt="Next"
                loading="lazy"
              />
            </>
          )}
          <p
            className={activeIndex === index ? styles.description : styles.descriptionBlack}
          >
            {slide?.content}
          </p>
          <div className={styles.locationDiv}>
            <img
              className={styles.locationIcon}
              src={
                activeIndex === index
                  ? "/img/icons/testimonial-profile.svg"
                  : "/img/icons/testimonial-profile2.svg"
              }
              alt="Profile"
              loading="lazy"
            />
            <div>
              <p
                className={activeIndex === index ? styles.location : styles.locationBlack}
              >
                {slide?.location}
              </p>
              <h2
                className={activeIndex === index ? styles.name : styles.nameBlack}
              >
                {slide?.name}
              </h2>
            </div>
          </div>
        </div>
      </SwiperSlide>
    ));
  }, [data?.listingItems, activeIndex]);

  // Validate data
  if (!data?.listingItems?.length) {
    return null;
  }

  return (
    <div className={styles.outer}>
      <div className={styles.title} data-aos="fade-down" data-aos-delay="150">
        <h1 className="bg-primary-200 primary-300">{data?.subTitle}</h1>
        <div>
          {data?.showTitle && (
            <div className={styles.titleFirst}>
              <h2 dangerouslySetInnerHTML={{ __html: data?.title }}></h2>
            </div>
          )}
        </div>
      </div>
      <Swiper
        spaceBetween={width > 1200 ? 50 : 30}
        slidesPerView={width>768 ? 2 : 1}
        centeredSlides={true}
        loop={data.listingItems.length > 1} // Disable loop for single slide
        modules={[Autoplay]}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true, // Pause on hover
        }}
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
          setActiveIndex(swiper.realIndex);
        }}
        className={styles.swiperContainer}
      >
        {slides}
      </Swiper>
    </div>
  );
}

export default React.memo(TestimonialWidget);